import { createSlice } from "@reduxjs/toolkit";
import { SHORTCUTKEYS } from "../../../constants/reducer_names";

const initialState = {
    globalSearch : false as boolean,
    agentTracker : false as boolean,
    muteUnmute : false as boolean,
    hangCall : false as boolean,
    createCustomer : false as boolean,
    transferOnly : false as boolean,
    offline : false as boolean,
    answerIncomingCall : false as boolean,
    declineIncomingCall : false as boolean,
    readyState : false as boolean,
    logOut : false as boolean,
    away : false as boolean,
    notReady : false as boolean,
    isUpdate : false as boolean,
    openUpdateForm : false as boolean,
    isBellModalOpen: false as Boolean
}; 

const shortcutKeySlice = createSlice({
    name:SHORTCUTKEYS,
    initialState,
    reducers:{
        propsValue:(state,{payload})=> {
            state.globalSearch = payload.globalSearch;
            state.agentTracker = payload.agentTracker;
            state.muteUnmute = payload.muteUnmute;
            state.hangCall = payload.hangCall;
            state.createCustomer = payload.createCustomer;
            state.transferOnly = payload.transferOnly;
            state.offline = payload.offline;
            state.answerIncomingCall = payload.answerIncomingCall;
            state.declineIncomingCall = payload.declineIncomingCall;
            state.readyState = payload.readyState;
            state.logOut = payload.logOut;
            state.away = payload.away;
            state.notReady = payload.notReady;
            state.openUpdateForm = payload.openUpdateForm
        },
        updateValue:(state,{payload})=> {
            state.isUpdate = payload.isUpdate;
        },
        setOpenUpdateForm: (state, { payload }) => {
            state.openUpdateForm = payload.open;
        },
        setIsBellModalOpen: (state, { payload }) => {
            state.isBellModalOpen = payload
        }
    }

});

export const shortcutKeyActions = shortcutKeySlice.actions;
export const shortcutKeysReducer = shortcutKeySlice.reducer;